import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyFullWidthLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/fullWidth" */ './FullWidth'), 'FullWidthLayout');
